import React from 'react';
import { clamp } from '../../../utils/clamp';
import { HeadingLevelProvider, useHeadingLevel, } from '@zapier/heading-level-context';
export const HeadingLevel = ({ children }) => {
    const { level } = useHeadingLevel();
    const nextLevel = clamp(level + 1, 1, 6);
    return (React.createElement(HeadingLevelProvider, { level: nextLevel }, children));
};
//# sourceMappingURL=HeadingLevel.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
